import './main.css';   // ← this now works
import App from './App.svelte';

const app = new App({
	target: document.body,
});

export default app;